const ProductSearchHelper = {
  prepareForServer: (search) => {
    search = { ...search };
    search.filters = { ...search.filters };

    for (let filter in search.filters) {
      if (filter === "category_id") {
        continue;
      }

      if (filter === "price") {
        if (
          !search.filters[filter] ||
          !Array.isArray(search.filters[filter]) ||
          search.filters[filter].length === 0 ||
          !search.filters[filter][0] ||
          !search.filters[filter][0].id ||
          typeof search.filters[filter][0].id !== "string" ||
          !search.filters[filter][0].id.startsWith("range:")
        ) {
          delete search.filters[filter];
          continue;
        }

        try {
          const arr = search.filters[filter][0].id.substr(6).split("-");

          if (
            arr.length !== 2 ||
            isNaN(parseInt(arr[0])) ||
            isNaN(parseInt(arr[1]))
          ) {
            delete search.filters[filter];
            continue;
          }

          search.filters[filter] = {
            from: parseInt(arr[0]) * 100,
            to: parseInt(arr[1]) * 100,
          };
        } catch (error) {
          console.warn("Error processing price filter:", error);
          delete search.filters[filter];
        }

        continue;
      }

      const ids = [];

      for (let i = 0; i < search.filters[filter].length; i++) {
        ids.push(search.filters[filter][i].id);
      }

      search.filters[filter] = ids;
    }

    search.list = search.list || "default";

    search.sort = {
      field: search.sort?.field || "refreshed_at",
      direction: search.sort?.direction || "desc",
    };

    return search;
  },

  buildUrl: ({ list, query, sort, filters }) => {
    const _this = ProductSearchHelper;

    let url = "/products";

    if (list && (list !== "new" || !filters.category_id)) {
      const specialLists = {
        new: "new",
        favourites: "favourite",
        wishlist: "wishlist",
      };
      url += "/" + specialLists[list];
    }

    if (filters.category_id) {
      const allowedCategories = { 9: "watches", 3: "bags", 4: "cigars" };
      url += "/" + allowedCategories[filters.category_id];
    }

    if (query) {
      url += "/q/" + encodeURIComponent(query);
    }

    url += _this.buildFiltersUrlPart(filters);

    if (sort.field) {
      url += "/sort/" + sort.field + "/" + sort.direction;
    }

    return url;
  },

  buildFiltersUrlPart: (filters) => {
    let urlPart = "";

    for (let filter in filters) {
      if (filter === "category_id") {
        continue;
      }

      if (!filters[filter]?.length) {
        continue;
      }

      if (filter === "brand_id" || filter === "model_id") {
        urlPart += "/" + filter.split("_")[0] + "/";
      } else {
        urlPart += "/" + filter + "/";
      }

      filters[filter].sort(function(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });

      urlPart += filters[filter]
        .map((v) => {
          if (filter === "brand_id" || filter === "model_id") {
            return v.id + "," + encodeURIComponent(v.name);
          } else {
            return encodeURIComponent(v.name);
          }
        })
        .join("|");
    }

    return urlPart;
  },

  parseUrl: ({ pathname }, failonError = true) => {
    const _this = ProductSearchHelper;

    const result = {
      list: null,
      query: "",
      sort: {},
      filters: {},
    };

    let withoutQueryParams = pathname.split("?")[0];
    let urlParts = withoutQueryParams.split("/").slice(2);

    urlParts = _this._parseCategoryPart(urlParts, result);
    urlParts = _this._parseCategoryPart(urlParts, result);

    while (urlParts.length > 0) {
      urlParts = _this._parseNextPart(urlParts, result);

      if (urlParts === false) {
        return failonError ? false : result;
      }
    }

    return result;
  },

  _parseCategoryPart: (urlParts, result) => {
    const allowedCategories = { watches: 9, bags: 3, cigars: 4 };
    const specialLists = {
      new: "new",
      favourite: "favourites",
      wishlist: "wishlist",
    };

    if (allowedCategories[urlParts[0]]) {
      result.filters.category_id = allowedCategories[urlParts[0]];
      return urlParts.slice(1);
    }

    if (specialLists[urlParts[0]]) {
      result.list = specialLists[urlParts[0]];
      return urlParts.slice(1);
    }

    return urlParts;
  },

  _parseNextPart: (urlParts, result) => {
    const _this = ProductSearchHelper;

    const sortFields = ["price", "created_at", "is_investment"];

    const filterFields = [
      "brand",
      "model",
      "price",
      "case_material",
      "case_diameter",
      "dial_color",
      "condition",
      "location",
      "color",
    ];

    if (urlParts[0] === "sort") {
      if (
        !sortFields.includes(urlParts[1]) ||
        !["asc", "desc"].includes(urlParts[2])
      ) {
        return false;
      }

      result.sort = {
        field: urlParts[1],
        direction: urlParts[2],
      };

      return urlParts.slice(3);
    }

    if (urlParts[0] === "q") {
      result.query = decodeURIComponent(urlParts[1]);
      return urlParts.slice(2);
    }

    if (!filterFields.includes(urlParts[0])) {
      return false;
    }

    let filterName = urlParts[0];

    if (filterName === "brand" || filterName === "model") {
      filterName += "_id";
    }

    result.filters[filterName] = _this.parseFilterValues(
      filterName,
      urlParts[1]
    );
    return urlParts.slice(2);
  },

  parseFilterValues: (filter, values) => {
    return values.split("|").map((str) => {
      if (filter === "brand_id" || filter === "model_id") {
        const arr = str.split(",");

        return {
          id: parseInt(arr[0]),
          name: arr.slice(1).join(","),
        };
      }

      return {
        id: decodeURIComponent(str),
        name: decodeURIComponent(str),
      };
    });
  },

  formatFilterName: (filter) => {
    if (filter === "brand_id") {
      return "brand";
    }

    if (filter === "model_id") {
      return "model";
    }

    return filter.split("_").join(" ");
  },

  formatPluralFilterName: (filter) => {
    const filterName = ProductSearchHelper.formatFilterName(filter);
    if (filterName === "status") {
      return "Status"; // Corrected pluralization
    }
    return filterName + "s";
  },
};

export default ProductSearchHelper;
